import axios from "axios";

const state = {
  eventos: [],
};

const mutations = {
  SET_EVENTOS(state, eventos) {
    state.eventos = eventos;
  },
  ADD_EVENTO(state, evento) {
    state.eventos.push(evento);
  },
  UPDATE_EVENTO(state, evento) {
    const idx = state.eventos.findIndex((e) => e.id === evento.id);
    if (idx !== -1) state.eventos.splice(idx, 1, evento);
  },
  DELETE_EVENTO(state, id) {
    state.eventos = state.eventos.filter((e) => e.id !== id);
  },
};

const actions = {
  async fetchEventos({ commit }) {
    try {
      const { data } = await axios.get("/api/evento");
      commit("SET_EVENTOS", data);
    } catch (e) {
      console.error("Error fetching eventos:", e);
      throw e;
    }
  },
  async getEventoById(_, id) {
    try {
      const { data } = await axios.get(`/api/evento/${id}`);
      return data;
    } catch (e) {
      console.error("Error getting evento:", e);
      throw e;
    }
  },
  async guardarEvento({ commit }, evento) {
    try {
      const { data } = await axios.post("/api/evento", evento);
      commit("ADD_EVENTO", data);
      return data;
    } catch (e) {
      console.error("Error saving evento:", e);
      throw e;
    }
  },
  async updateEvento({ commit }, evento) {
    try {
      const { data } = await axios.put(`/api/evento/${evento.id}`, evento);
      commit("UPDATE_EVENTO", data);
      return data;
    } catch (e) {
      console.error("Error updating evento:", e);
      throw e;
    }
  },
  async deleteEvento({ commit }, id) {
    try {
      await axios.delete(`/api/evento/${id}`);
      commit("DELETE_EVENTO", id);
    } catch (e) {
      console.error("Error deleting evento:", e);
      throw e;
    }
  },
};

const getters = {
  eventos: (state) => state.eventos,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
